import React from 'react';
import { Container, Row, Col, Card, Spinner, Alert, Badge, Button } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { tagsAPI } from '../services/api';
import { Tag as TagIcon, Plus } from 'lucide-react';
import { Link } from 'react-router-dom'; // Import Link for future navigation

const TagsPage = () => {
  const { data: tagsData, isLoading, error } = useQuery(
    ['tags', 'all'],
    () => tagsAPI.getTags({ limit: 1000 }), // Fetch a generous limit of tags
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
    }
  );

  if (isLoading) {
    return (
      <Container fluid className="text-center py-5">
        <Spinner animation="border" />
        <p className="mt-3">Lade Tags...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container fluid>
        <Alert variant="danger">
          <Alert.Heading>Fehler beim Laden der Tags</Alert.Heading>
          <p>{error.message}</p>
          <Button onClick={() => window.location.reload()}>Nochmal versuchen</Button>
        </Alert>
      </Container>
    );
  }

  const tags = tagsData?.data || []; // Access the 'data' property for the array of tags

  return (
    <Container fluid>
      <Row className="mb-4">
        <Col className="d-flex justify-content-between align-items-center">
          <h1 className="h3 mb-0">Tags ({tags.length})</h1> {/* Anzahl der Tags */}
          <Link to="/tags/create" className="btn btn-primary">
            <Plus size={16} className="me-2" />
            Tag erstellen
          </Link>
        </Col>
      </Row>

      <Row>
        <Col>
          {tags.length === 0 ? (
            <Card>
              <Card.Body className="text-center py-5">
                <TagIcon size={48} className="text-muted mb-3" />
                <h5 className="text-muted">Keine Tags gefunden</h5>
                <p className="text-muted">Erstelle deinen ersten Tag, um zu beginnen!</p>
                <Link to="/tags/create" className="btn btn-primary">
                  <Plus size={16} className="me-2" />
                  Tag erstellen
                </Link>
              </Card.Body>
            </Card>
          ) : (
            <div className="d-flex flex-wrap gap-2">
              {tags.map((tag) => (
                <Badge
                  key={tag._id}
                  bg="secondary" // Standard Hintergrund
                  style={{ backgroundColor: tag.color || '#6c757d', cursor: 'pointer' }} // Use tag.color
                  className="p-2 d-flex align-items-center"
                  //onClick={() => navigate(`/prompts?tags=${tag._id}`)} // Future feature: filter prompts by tag */}
                >
                  <TagIcon size={14} className="me-1" />
                  {tag.displayName} ({tag.usage.promptCount || 0}) {/* Anzahl der Prompts mit diesem Tag */}
                </Badge>
              ))}
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default TagsPage;